module.exports = __webpack_public_path__ + "static/media/buy-n-large.a4c19c3e.svg";